module.exports = __webpack_public_path__ + "img/aiimg3.ea29e91a.png";